import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CardChecklistsPatcherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardChecklistsPatcher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checklists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checklistsAll"},"name":{"kind":"Name","value":"checklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"all"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checklistsDue"},"name":{"kind":"Name","value":"checklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"due"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CardChecklistsPatcher","document":CardChecklistsPatcherDocument}} as const;
export type CardChecklistsPatcherQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID'];
}>;


export type CardChecklistsPatcherQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id'>
    & { checklists: Array<(
      { __typename: 'Checklist' }
      & Pick<Types.Checklist, 'id'>
    )>, checklistsAll: Array<(
      { __typename: 'Checklist' }
      & Pick<Types.Checklist, 'id'>
    )>, checklistsDue: Array<(
      { __typename: 'Checklist' }
      & Pick<Types.Checklist, 'id'>
    )> }
  )> }
);

/**
 * __useCardChecklistsPatcherQuery__
 *
 * To run a query within a React component, call `useCardChecklistsPatcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardChecklistsPatcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardChecklistsPatcherQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCardChecklistsPatcherQuery(
  baseOptions: TrelloQueryHookOptions<
    CardChecklistsPatcherQuery,
    CardChecklistsPatcherQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: CardChecklistsPatcherDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    CardChecklistsPatcherQuery,
    CardChecklistsPatcherQueryVariables
  >(CardChecklistsPatcherDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useCardChecklistsPatcherLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    CardChecklistsPatcherQuery,
    CardChecklistsPatcherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CardChecklistsPatcherQuery,
    CardChecklistsPatcherQueryVariables
  >(CardChecklistsPatcherDocument, options);
}
export type CardChecklistsPatcherQueryHookResult = ReturnType<
  typeof useCardChecklistsPatcherQuery
>;
export type CardChecklistsPatcherLazyQueryHookResult = ReturnType<
  typeof useCardChecklistsPatcherLazyQuery
>;
export type CardChecklistsPatcherQueryResult = Apollo.QueryResult<
  CardChecklistsPatcherQuery,
  CardChecklistsPatcherQueryVariables
>;
